import { ExEmptyState } from '@boomi/exosphere';
import { FABRIC_BASE_URL } from '../config';
import styles from './NoSearchResults.module.css';

interface NoSearchResultsProps {
    itemLabel: string;
    search?: string;
}

const NoSearchResults = ({ itemLabel, search }: NoSearchResultsProps) => (
    <ExEmptyState
        className={styles.noResults}
        label="No Results"
        text={`No ${itemLabel} found${search && ` for "${search}"`}`}
    >
        <div slot="header">
            <img src={`${FABRIC_BASE_URL}/emptyStateIcon.svg`} alt="No Results" />
        </div>
    </ExEmptyState>
);

export default NoSearchResults;
